import { Fragment as t } from "react";
function f(r) {
  return Array.isArray(r) || r === null ? !1 : typeof r == "object" ? r.type !== t : !1;
}
export {
  f as i
};
